import React, { useCallback, useContext, useMemo } from "react";
import debounce from "lodash-es/debounce";
import AddCustomer from "./AddCustomer";
import SelectCustomer from "./SelectCustomer";
import { AllProductContext } from "../../context/AllProductProvider";

function SearchandCustomer({ searched, setSearched }) {
  const { setAllProduct } = useContext(AllProductContext);

  const debouncedSearch = useMemo(
    () =>
      debounce((search) => {
        setSearched(search);
      }, 500),
    [setSearched]
  );

  // ✅ Memoized search handler
  const handleSearchChange = useCallback(
    (e) => {
      setAllProduct(true);
      const value = e.target.value;
      setSearched(value);
      debouncedSearch(value);
    },
    [setAllProduct, setSearched, debouncedSearch]
  );

  return (
    <div className="w-full px-3 pt-3">
      <div className="flex justify-between items-center">
        <input
          placeholder="Search for"
          type="text"
          value={searched}
          onChange={handleSearchChange}
          className="border-2 rounded-sm border-gray-400 w-60 p-1.5 px-4"
        />
        <div className="flex items-center gap-8">
          <SelectCustomer />
          <AddCustomer />
        </div>
      </div>
    </div>
  );
}

export default React.memo(SearchandCustomer);
